import React from 'react'
import { faListUl } from '@fortawesome/pro-regular-svg-icons'
import { SectionWrapper } from '../../../../common/components/SectionWrapper/SectionWrapper'
import {
  DetailRow,
  DetailInfo,
} from '../../../../common/components/DetailRow/DetailRow'
import { ProductNameWithExternalLink } from '../../../../common/components/ProductNameWithExternalLink/ProductNameWithExternalLink'
import { ShortenedNameV2 } from '@labrav/common'
import { PlanType } from '@labrav/react-components'
import { SubscriptionDetailObject } from '../../../../modules/subscription/reducer'
import { TruncateWithLink } from '../../../../common/components/TruncateWithLink/TruncateWithLink'
import { ViewValueWithTruncate } from '@labrav/common'
import { AzurePricingType } from '../../../../types/flyout'

interface ProductDetailsSectionProps {
  subscriptionDetail: SubscriptionDetailObject
  cloudType: string
  classes: any
}

export const ProductDetailsSection: React.FC<ProductDetailsSectionProps> = ({
  subscriptionDetail,
  cloudType,
  classes,
}) => {
  return (
    <SectionWrapper heading="Product details" icon={faListUl}>
      <div className={classes.sectionContent}>
        <DetailRow borderBottom props={{ spacing: 1 }}>
          <>
            <DetailInfo
              title="Product"
              value={
                cloudType === 'AZURE' &&
                subscriptionDetail.productDetails?.marketplaceUrl ? (
                  <TruncateWithLink
                    text={subscriptionDetail.productDetails.productName}
                    link={
                      subscriptionDetail.productDetails?.marketplaceUrl ||
                      'https://app.labra.io'
                    }
                  />
                ) : (
                  <ProductNameWithExternalLink
                    productName={
                      <ShortenedNameV2
                        name={subscriptionDetail.productDetails.productName}
                        length={35}
                      />
                    }
                    productId={subscriptionDetail.productDetails.labraProductId}
                  />
                )
              }
              keyName="product"
            />
            <DetailInfo
              title="Product ID"
              value={
                <ViewValueWithTruncate
                  value={subscriptionDetail.productDetails.productCode}
                  showIcon={true}
                />
              }
              keyName="productId"
            />
          </>
        </DetailRow>
        <DetailRow borderBottom={false} props={{ spacing: 1 }}>
          <>
            <DetailInfo
              title="Pricing model"
              value={
                subscriptionDetail.productDetails.productType ===
                PlanType.SAAS_SUBSCRIPTION
                  ? 'SaaS subscription'
                  : subscriptionDetail.productDetails.productType ===
                      PlanType.SAAS_CONTRACT
                    ? 'SaaS contract'
                    : subscriptionDetail.productDetails.productType ===
                        PlanType.PROFESSIONAL_SERVICES
                      ? 'Professional services'
                      : subscriptionDetail.productDetails.productType ===
                          PlanType.CONTAINER
                        ? 'Container'
                        : '-'
              }
              keyName="pricingModel"
            />
            {cloudType === 'AZURE' && (
              <DetailInfo
                title="Pricing configuration"
                value={
                  subscriptionDetail.privateOfferPlanDetails?.discountType ===
                  AzurePricingType?.ABSOLUTE
                    ? 'Absolute'
                    : 'Discount'
                }
                keyName="pricingConfiguration"
              />
            )}
          </>
        </DetailRow>
      </div>
    </SectionWrapper>
  )
}
